'use client';

import { useState } from 'react';

/**
 * @function getIconSize - To get size of tileArrowIcon
 * @param {boolean} tileIcon - Boolean indicating wheather tile icon is present
 * @param {boolean} sm - Boolean for indicating small screen size
 * @returns {number} Icon size in pixels based on screen size
 */
export const getIconSize = (tileIcon, sm) => {
  if (tileIcon) return 32;
  return sm ? 50 : 62;
};

/**
 * @function useHoverEffect - Custom hook to manage hover and touch interactions
 * @returns {object} - An object hover and touch interaction states
 */
export const useHoverEffect = () => {
  const [isHovered, setIsHovered] = useState(false);

  /**
   * @function handleMouseEnter - Event handler for mouse enter
   */
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  /**
   * @function handleMouseLeave - Event handler for mouse leave
   */
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  /**
   * @function handleTouchStart - Event handler for touch start
   */
  const handleTouchStart = () => {
    setIsHovered(!isHovered);
  };

  /**
   * @function handleFocus - Event handler for on focus tab key press
   */
  const handleFocus = () => {
    setIsHovered(true);
  };

  /**
   * @function handleBlur - Event handler when component loses focus
   */
  const handleBlur = () => {
    setIsHovered(false);
  };

  return {
    isHovered,
    handleMouseEnter,
    handleMouseLeave,
    handleTouchStart,
    handleFocus,
    handleBlur,
  };
};
